import { Link } from 'react-router-dom'

export function CandidateWarning() {
  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2.5">
      <div className="max-w-5xl mx-auto flex items-start gap-3 text-sm text-amber-800">
        <span className="text-lg leading-none mt-0.5 shrink-0" aria-hidden>📖</span>
        <p>
          <strong>Community review dictionary.</strong>{' '}
          Help improve accuracy by clicking <strong>"Suggest Correction"</strong> on any entry.
          See the{' '}
          <Link to="/about" className="underline font-medium hover:text-amber-900">
            About page
          </Link>{' '}
          for details.
        </p>
      </div>
    </div>
  )
}
